import React from 'react';
import styled from 'styled-components';
import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';
import { getUrlFromStashedFilters } from '../../../SearchPage/controllers/filtersController';

type Props = {
  path: string;
  isMobile: boolean;
};

const NoOnlyMenValidationText = ({ path, isMobile }: Props) => {
  const { t } = useTranslation();
  return (
    <div>
      <StyledNoOnlyMenValidationText>
        <WarningText>
          <Title mobile={isMobile}>
            {t('checkout.touristForm.noOnlyMen.title')}
          </Title>
          <Text>
            {t('checkout.touristForm.noOnlyMen.text')}{' '}
            <a href={getUrlFromStashedFilters(path)}>
              {t('checkout.touristForm.noOnlyMen.link')}
            </a>
            {t('checkout.touristForm.noOnlyMen.continueText')}
          </Text>
        </WarningText>
        <a href={getUrlFromStashedFilters(path)}>
          <StyledButton mobile={isMobile}>
            {t('checkout.touristForm.noOnlyMen.repeatSearch')}
          </StyledButton>
        </a>
      </StyledNoOnlyMenValidationText>
    </div>
  );
};

export const StyledNoOnlyMenValidationText = styled.div`
  background-color: #f9eaec;
  padding: 8px;
  width: 100%;
  border-radius: 4px;
  position: relative;
  a {
    text-decoration: none;
    color: #007aff;
  }
`;

const Title = styled.span<{ mobile?: boolean }>`
  font-weight: bold;
  font-size: ${(props) => (props.mobile ? '16px' : '22px')};
  line-height: ${(props) => (props.mobile ? '20px' : '26px')};
  color: #17181a;
`;

export const Text = styled.span`
  display: block;
  margin: 8px 0px;
`;

export const StyledButton = styled(Button)<{ mobile?: boolean }>`
  min-width: ${(props) => (props.mobile ? '100%' : '241px')};
  max-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;

const WarningText = styled.p`
  font-family: Backpack;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #4d4d4d;
  margin-bottom: 16px;
  max-width: 600px;
`;

export default NoOnlyMenValidationText;
